<template lang="pug">
  SspLayout.ati-edit(area="core")
    SspSaveForm(@onSubmit="save" :saving="saving")
      .form-group
        label.col-sm-4.control-label Name
        .col-sm-8
          input.form-control(type="text" v-model="ati.name" placeholder="Enter name")
      .form-group
        label.col-sm-4.control-label(for="type") Type
        .col-sm-8
          select.form-control(v-model="ati.type")
            option(v-for="t in atiTypes" :value="t.value") {{ t.label }}
      .form-group
        label.col-sm-4.control-label Translations
        .col-sm-8
          ul.nav.nav-tabs
            li(v-for="(mt, index) in messageTypes" :class=" { active: activeMessageTypeIndex === index } " @click="switchTranslationMessageType(index)")
              a(@click="switchTranslationMessageType(index)") {{ mt.label }}
          .tab-pane
            .form-group
              label.col-sm-2.control-label Country
              .col-sm-10
                CountrySelect(ref="countrySelect" v-model="country" placeholder="(Default)")
            .form-group
              label.col-sm-2.control-label Help
              .col-sm-10
                button.ati-help-button.btn.btn-default(type="button" @click="$refs.atiHelpModal.open()") Open Help
            .form-group
              .col-sm-2
              .col-sm-10
                ToolbarDropdownMenu(:contextMenus="atiToolbarMenu" @selection="addMessageItem")
            .form-group
              label.col-sm-2.control-label Message
              .col-sm-10
                textarea.message.form-control(ref="atiMessage" v-model="message" @blur="addTranslation()")
            .form-group(v-if="activeMessageTypeIndex === 0")
              .col-sm-2
              .col-sm-10
                button.html-preview-button.btn.btn-default(type="button" @click="$refs.htmlPreviewModal.open()") Preview HTML Message

      .form-group
        label.col-sm-4.control-label Time of activation
        .col-sm-8
          input.form-control(type="text" v-model="ati.activate")
      .form-group
        label.col-sm-4.control-label Time of deactivation
        .col-sm-8
          input.form-control(type="text" v-model="ati.deactivate")
      .form-group
        label.col-sm-4.control-label Number of validations for activation
        .col-sm-8
          input.form-control(type="number" v-model="ati.validationsRangeStart")
      .form-group
        label.col-sm-4.control-label Number of validations for deactivation
        .col-sm-8
          input.form-control(type="number" v-model="ati.validationsRangeEnd")

    HtmlPreviewModal(ref="htmlPreviewModal" :html="message")
    AtiHelpModal(ref="atiHelpModal")

</template>
<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import CountrySelect from '@/components/ssp/CountrySelect'
import atiToolbarMenu from '@/data/components/toolbar/atiToolbarMenu.json'
import HtmlPreviewModal from '@/components/common/HtmlPreviewModal'
import ToolbarDropdownMenu from '@/components/ssp/ToolbarDropdownMenu'
import { cloneDeep, union, spread } from '@/utils/lodash'
import AtiHelpModal from './AtiHelpModal'

export default {
  data: () => ({
    saving: false,
    ati: {
      activate: null,
      deactivate: null,
      name: null,
      smsMessage: '',
      translations: {
        translation: []
      },
      type: null,
      validationsRangeEnd: null,
      validationsRangeStart: null,
      webMessage: ''
    },
    loading: false,
    country: null,
    message: null,
    atiTypes: [
      { value: 'N', label: 'STANDARD' },
      { value: 'W', label: 'WARNING' },
      { value: 'F', label: 'FINAL' }
    ],
    activeMessageTypeIndex: 0,
    messageTypes: [
      { value: 'webMessage', label: 'WEB Message' },
      { value: 'smsMessage', label: 'SMS Message' }
    ],
    atiToolbarMenu: {}
  }),
  created() {
    this.atiToolbarMenu = cloneDeep(atiToolbarMenu)

    if (this.atiId) {
      this.fetchData()
    }
    this.getMetadataSchemaProperties()
    this.getProductMetadataSchemaProperties()
  },
  methods: {
    switchTranslationMessageType(index) {
      this.activeMessageTypeIndex = index
    },
    save() {
      this.saving = true
      const call = this.atiId ? Core.updateAti(this.atiId, this.ati) : Core.saveAti(this.ati)
      const action = this.atiId ? 'updated' : 'created'
      call
        .then(() => {
          miniToastr.success(`Validation response successfully ${action}`)
          this.$router.push({ name: 'atis' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    getTranslation() {
      if (this.country) {
        const existingTranslation = this.ati.translations.translation.find((t) => t.country === this.country.code)

        if (existingTranslation) {
          if (this.activeMessageTypeIndex === 0) {
            this.message = existingTranslation.webMessage
          } else {
            this.message = existingTranslation.smsMessage
          }
        } else {
          this.message = null
        }
      } else if (this.activeMessageTypeIndex === 0) {
        this.message = this.ati.webMessage
      } else {
        this.message = this.ati.smsMessage
      }
    },
    addTranslation() {
      if (this.country) {
        const foundTranslation = this.ati.translations.translation.find((t) => t.country === this.country.code)
        if (foundTranslation) {
          if (this.activeMessageTypeIndex === 0) {
            foundTranslation.webMessage = this.message
          } else {
            foundTranslation.smsMessage = this.message
          }
        } else {
          this.ati.translations.translation.push({
            country: this.country.code,
            smsMessage: this.activeMessageTypeIndex === 1 ? this.message : '',
            webMessage: this.activeMessageTypeIndex === 0 ? this.message : ''
          })
        }

        this.$refs.countrySelect.highlightCountry(this.country)
      } else if (this.activeMessageTypeIndex === 0) {
        this.ati.webMessage = this.message
        this.ati.smsMessage = ''
      } else {
        this.ati.smsMessage = this.message
        this.ati.webMessage = ''
      }
    },
    fetchData() {
      Core.readAti(this.atiId)
        .then((resp) => {
          this.ati = resp.data
          this.message = resp.data.webMessage
          return this.ati.translations
        })
        .then((translations) => {
          if (translations.translation) {
            translations.translation.forEach((el) => {
              this.$refs.countrySelect.highlightCountry(el.country)
            })
          }
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })
    },
    getMetadataSchemaProperties() {
      const params = {
        includeJson: true
      }
      Core.getMetadataSchemas(params)
        .then((resp) => {
          const properties = []
          resp.data.schema.forEach((s) => {
            const schema = JSON.parse(s.content)
            properties.push(Object.keys(schema.properties))
          })
          return properties
        })
        .then((props) => {
          const metadataProperties = spread(union)(props).sort()
          const orderMenu = this.atiToolbarMenu[1]
          const sectionMenu = this.atiToolbarMenu[2]
          orderMenu.children.push({
            label: 'metadata',
            children: metadataProperties.map((m) => ({ label: m }))
          })

          sectionMenu.children.push({
            label: 'metadata',
            children: metadataProperties.map((m) => ({ label: m }))
          })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    getProductMetadataSchemaProperties() {
      const params = {
        includeJson: true
      }
      Core.listProductMetadataSchemas(params)
        .then((resp) => {
          const properties = []
          resp.data.schema.forEach((s) => {
            const schema = JSON.parse(s.content)
            properties.push(Object.keys(schema.properties))
          })
          return properties
        })
        .then((props) => {
          const productMetadataProperties = spread(union)(props).sort()
          const productMenu = this.atiToolbarMenu[3]
          productMenu.children.push({
            label: 'metadata',
            children: productMetadataProperties.map((m) => ({ label: m }))
          })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    insertAtPostion(value, position) {
      this.$refs.atiMessage.focus()
      if (position) {
        return [this.message.slice(0, position), value, this.message.slice(position)].join('')
      }
      this.message = this.message + value
      return this.message
    },
    addMessageItem(value) {
      const position = this.$refs.atiMessage.selectionStart
      const split = value.split('.')
      if (split[0] === 'code') {
        this.message = this.insertAtPostion(`{{${split[1]}}}`, position)
        return
      }
      if (split[0] === 'filters') {
        this.message = this.insertAtPostion(`| ${split[1]}`, position)
        return
      }
      this.message = this.insertAtPostion(`{{${value}}}`, position)
    }
  },
  watch: {
    country() {
      this.getTranslation()
    },
    activeMessageTypeIndex() {
      this.getTranslation()
    }
  },
  computed: {
    atiId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    CountrySelect,
    HtmlPreviewModal,
    ToolbarDropdownMenu,
    AtiHelpModal
  }
}
</script>

<style lang="scss">
.ati-edit {
  .html-preview-button {
    width: 100%;
  }
  .ati-help-button {
    width: 100%;
  }
  .nav-tabs {
    li {
      width: 50% !important;
      text-align: center;
    }
  }
  .message {
    max-width: 100%;
    min-height: 200px;
  }

  .tab-pane {
    padding: 8px;
    border: solid #ddd 1px;
    border-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/ati/AtiEdit.vue